var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "155", height: "2", viewBox: "0 0 155 2", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { fill: "#000", fillRule: "nonzero", opacity: ".687" },
      React.createElement("rect", { width: "1.646", height: "1.646", rx: ".823" }),
      React.createElement("rect", { x: "59.241", width: "1.646", height: "1.646", rx: ".823" }),
      React.createElement("rect", { x: "29.62", width: "1.646", height: "1.646", rx: ".823" }),
      React.createElement("rect", { x: "88.861", width: "1.646", height: "1.646", rx: ".823" }),
      React.createElement("rect", { x: "9.873", width: "1.646", height: "1.646", rx: ".823" }),
      React.createElement("rect", { x: "69.114", width: "1.646", height: "1.646", rx: ".823" }),
      React.createElement("rect", { x: "39.494", width: "1.646", height: "1.646", rx: ".823" }),
      React.createElement("rect", { x: "98.734", width: "1.646", height: "1.646", rx: ".823" }),
      React.createElement("rect", { x: "118", width: "1.646", height: "1.646", rx: ".823" }),
      React.createElement("rect", { x: "143", width: "1.646", height: "1.646", rx: ".823" }),
      React.createElement("rect", { x: "19.747", width: "1.646", height: "1.646", rx: ".823" }),
      React.createElement("rect", { x: "78.987", width: "1.646", height: "1.646", rx: ".823" }),
      React.createElement("rect", { x: "49.367", width: "1.646", height: "1.646", rx: ".823" }),
      React.createElement("rect", { x: "109", width: "1.646", height: "1.646", rx: ".823" }),
      React.createElement("rect", { x: "133", width: "1.646", height: "1.646", rx: ".823" }),
      React.createElement("rect", { x: "128", width: "1.646", height: "1.646", rx: ".823" }),
      React.createElement("rect", { x: "153", width: "1.646", height: "1.646", rx: ".823" }),
      React.createElement("rect", { x: "4.937", width: "1.646", height: "1.646", rx: ".823" }),
      React.createElement("rect", { x: "64.177", width: "1.646", height: "1.646", rx: ".823" }),
      React.createElement("rect", { x: "34.557", width: "1.646", height: "1.646", rx: ".823" }),
      React.createElement("rect", { x: "93.797", width: "1.646", height: "1.646", rx: ".823" }),
      React.createElement("rect", { x: "14.81", width: "1.646", height: "1.646", rx: ".823" }),
      React.createElement("rect", { x: "74.051", width: "1.646", height: "1.646", rx: ".823" }),
      React.createElement("rect", { x: "44.43", width: "1.646", height: "1.646", rx: ".823" }),
      React.createElement("rect", { x: "103.671", width: "1.646", height: "1.646", rx: ".823" }),
      React.createElement("rect", { x: "123", width: "1.646", height: "1.646", rx: ".823" }),
      React.createElement("rect", { x: "148", width: "1.646", height: "1.646", rx: ".823" }),
      React.createElement("rect", { x: "24.684", width: "1.646", height: "1.646", rx: ".823" }),
      React.createElement("rect", { x: "83.924", width: "1.646", height: "1.646", rx: ".823" }),
      React.createElement("rect", { x: "54.304", width: "1.646", height: "1.646", rx: ".823" }),
      React.createElement("rect", { x: "114", width: "1.646", height: "1.646", rx: ".823" }),
      React.createElement("rect", { x: "138", width: "1.646", height: "1.646", rx: ".823" })
    )
  );
});